import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import type { Testimonial } from '../data/testimonials';
type Props = {
  testimonial: Testimonial;
  delay?: number;
};
export function TestimonialCard({
  testimonial,
  delay = 0
}: Props) {
  return <motion.figure initial={{
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.3,
    delay,
    ease: [0.23, 1, 0.32, 1]
  }} className="flex flex-col rounded-2xl border border-line bg-ink-2 p-5" data-id="element-305" data-mp="2p7g9druzygnj">
      <figcaption className="flex items-center gap-3" data-id="element-306" data-mp="3458nqgot4z05">
        <img src={testimonial.img} alt={`${testimonial.name}, ${testimonial.role}`} width={52} height={52} loading="lazy" decoding="async" className="h-[52px] w-[52px] shrink-0 rounded-full object-cover ring-2 ring-gold/60" data-id="element-307" data-mp="345qpfsu8o5fg" />
        <div className="min-w-0" data-id="element-308" data-mp="1dst59r5038f0">
          <p className="text-sm font-bold text-fog" data-id="element-309" data-mp="hskrct071m5o">{testimonial.name}</p>
          <p className="text-xs text-teal" data-id="element-310" data-mp="huxdzjgwckp2">{testimonial.role}</p>
          <p className="mt-0.5 flex items-center gap-1.5 text-xs text-fog/55" data-id="element-311" data-mp="d1ch5ur1hwrg">
            📍 {testimonial.location}
            <span aria-hidden="true" data-id="element-312" data-mp="83aw54a1zndc">{testimonial.flag}</span>
          </p>
        </div>
      </figcaption>
      <span className="mt-4 flex gap-0.5 text-gold" aria-label="5 out of 5 stars" data-id="element-313" data-mp="31tydhmv8h0z">
        {Array.from({
        length: 5
      }).map((_, k) => <StarIcon key={k} className="h-4 w-4 fill-current" aria-hidden="true" data-id="element-314" data-mp="vsvkk2oz7cu0" data-mpi={k} />)}
      </span>
      <blockquote className="mt-3 flex-1 text-[15px] leading-relaxed text-fog/80" data-id="element-315" data-mp="qsznyoilynoh">“{testimonial.quote}”</blockquote>
    </motion.figure>;
}